import { Component, ViewChild, OnInit, Input, Output, EventEmitter, OnChanges, AfterViewInit, ChangeDetectorRef, SimpleChanges, TemplateRef, ElementRef, Inject } from '@angular/core';
import { LoaderService } from '../../shared/loader/loader.service';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { Observable, Subscription } from 'rxjs';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';

@Component({
  selector: 'app-addurlinFolder',
  templateUrl: './addurlinFolder.component.html',
  styleUrls: ['./addurlinFolder.component.scss'] 
})

export class AddUrlinFolderComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  formDialog: FormGroup;   
  formfoldername:string="";
  disabledUpdate:boolean=true;
  spinner:boolean=false;
  successUrl:string="";
  declineUrl:string="";
  formFolderID:number=0;
  OfficeIDList: any = [];
  myOfficeID: any;
  constructor(private dialog: MatDialog, public dialogRef: MatDialogRef<AddUrlinFolderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private statusConst: StatusConstant,
    private formService: FormsService,private toastr: ToastrService,private statusConstant: StatusConstant) {   
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
    this.currentUser = jwt_decode(token); 
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }  
  
  ngOnInit(): void {
    this.data;
   // var formFolderName =Object.values(this.data)[0];
    // var type = Object.values(this.data)[3];
    // if(type ==1){
    // this.formfoldername="Folder";
    // }
    // if(type ==2){
    //   this.formfoldername="Template";
    //  }
    this.successUrl =  this.data.folderData.successUrl;
    this.declineUrl =  this.data.folderData.declineUrl;
    if(this.successUrl==null){
      this.successUrl="";
    }
    if(this.declineUrl==null){
      this.declineUrl="";
    }
    let groupaddtouchtype = {};
    this.formDialog = new FormGroup(groupaddtouchtype);
    this.formDialog.addControl('successurl', this.formBuilder.control(''));
    this.formDialog.addControl('declineurl', this.formBuilder.control(''));
    //this.formDialog.controls.formFolderName.setValue(formFolderName);
  }     
    

  addUpdateFolderUrl() {
    this.data;  
    var formFolderID = Object.values(this.data)[1];    

    if(this.successUrl==null){
      this.successUrl="";
    }
    if(this.declineUrl==null){
      this.declineUrl="";
    }
    if(this.showSuccessUrlMessage==true || this.showDeclineUrlMessage==true){
      return;
    }     
    if(this.successUrl=="" && this.declineUrl==""){ 
      this.toastr.warning('Please add Success/Decline Url.', '', {
        timeOut: 3000,
      });   
      return;    
    } else{
      this.addSuccessDeclineUrl(formFolderID);
    }  
  }
 

 addSuccessDeclineUrl(formFolderID){
   this.disabledUpdate=true;
   this.spinner=true;
   let ReqModel = {
    folderID: formFolderID,
    successUrl:this.successUrl,
    declineUrl:this.declineUrl, 
    organizationID: Number(this.organizationId),
    databaseID: parseInt(sessionStorage.getItem('databaseId')),
    UserId: this.currentUser.UID,
    officeID:this.myOfficeID
 }  
// return; 
 this.formService.configureFormFolderUrls(ReqModel).subscribe(response => {
   if (response != undefined) {
     this.responseHolder = response;
     if (this.responseHolder.data == true && this.responseHolder.status == this.statusConst.statusSuccess) {      
       this.formDialog.reset();
       this.dialogRef.close("Updated");
       this.toastr.success('Url added successfully.', '', {
         timeOut: 3000,
       });     
     }
    //  if (this.responseHolder.data == false && this.responseHolder.status == 500) {
    //     this.disabledUpdate=false;
    //     this.spinner=false;
    //     this.toastr.warning('Folder Name Already Exist.', '', {
    //     timeOut: 3000,
    //   });
    //  }   
   }
 });
 }



 close() {
  this.formDialog.reset();
  this.dialog.closeAll();
 }

 showSuccessUrlMessage:boolean=false;
 showDeclineUrlMessage:boolean=false;

 onSuccessURLChange(searchValue: string): void {  
  if(searchValue==""){
    this.showSuccessUrlMessage=false;
  }
  if(searchValue!=""){
   var regex = /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
   if(!regex.test(searchValue)) {
    this.showSuccessUrlMessage=true;
   }else{
    this.showSuccessUrlMessage=false;
   }
  }
}

onDeclineURLChange(searchValue: string): void {  
  if(searchValue==""){
    this.showDeclineUrlMessage=false;
  }
  if(searchValue!=""){
   var regex = /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
   if(!regex.test(searchValue)) {
    this.showDeclineUrlMessage=true;
   }else{
    this.showDeclineUrlMessage=false;
   }
  }
}
  
}
